import { Component, OnInit,ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { ProcesarPagoService } from 'src/app/service/procesarpago/procesar-pago.service';
import { OrderCalculateResponse } from 'src/app/modal/procesapago/orderCalculateResponse';
import { OrderCalculateRequest } from 'src/app/modal/procesapago/orderCalculateRequest';
import { OrderRequest } from 'src/app/modal/procesapago/orderRequest';
import { CarritoHeader } from 'src/app/modal/carrito/carrito-header';
import { LibroDetalle } from 'src/app/modal/catalogo/libro-detalle';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { InformacionEnvioComponent } from "src/app/pagina-externa/procesar-pago/informacion-envio/informacion-envio.component";
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { SourvenirDetalleResponse } from 'src/app/modal/sourvenir/sourvenir-detalle-response';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { ModalHomeComponent } from 'src/app/modal-home/modal-home.component';

@Component({
  selector: 'app-procesar-pago',
  templateUrl: './procesar-pago.component.html',
  styleUrls: ['./procesar-pago.component.scss']
})
export class ProcesarPagoComponent implements AfterViewInit, OnDestroy {
  
  // Modal de descuentos por volumen
  modalRefDescuentos: MDBModalRef;

  constructor(private procesarPagoService:ProcesarPagoService,
              private novedadesService:NovedadesService,
              private carritoService:CarritoService,
              private utilitarioService:UtilitarioService,
              private usuarioService: UsuarioService,
              private router: Router,
              private modalService: MDBModalService) { }

  @ViewChild(InformacionEnvioComponent) informacionEnvioComponent: InformacionEnvioComponent;
  carritoDetalle:CarritoHeader;  
  libroDetalle:LibroDetalle;
  precioTotal:number = 0;
  cantidadTotal:number = 0;
  weightTotal:number = 0;
  addressId:String;
  typeDeliveryId:String;
  orderCalculateResponse : OrderCalculateResponse = new OrderCalculateResponse();
  orderRequestInfoEnvio:OrderRequest = new OrderRequest();

  SubTotalTemp = 0;
  IGVProducto = 0;
  IGVDelivery = 0;
  IGVTotal = 0;
  monedaCarrito: string = 'S/.'; // Moneda del carrito (S/. o US$)

  mostrarModalTerminos: boolean = false;
  isCalculatingTotal: boolean = false;
  private intervalId: any;
  private cantidadAnterior: number = 0;

  // Desglose del resumen de pedido
  resumenPedido: {
    grupos: Array<{
      categoria: string;
      modalidad: string;
      cantidad: number;
      precioUnitario: number;
      subtotal: number;
      descuento: number;
      porcentajeDescuento: string;
    }>;
    subtotalSinDescuento: number;
    totalDescuentos: number;
    totalFinal: number;
  } = {
    grupos: [],
    subtotalSinDescuento: 0,
    totalDescuentos: 0,
    totalFinal: 0
  };    

  ngOnInit(): void {
    this.carritoService.verificarCarritoSelecionados();

    // Inicializar cantidad anterior
    this.cantidadAnterior = this.carritoService.cantidadCarrito;

    // Verificar cambios en el carrito cada segundo
    this.intervalId = setInterval(() => {
      this.verificarCambiosCarrito();
    }, 1000);

    // Mostrar popup de descuentos por volumen
    if (localStorage.getItem('hideDiscountModal') !== 'true' &&
        sessionStorage.getItem('discountModalShownInFlow') !== 'true') {
      setTimeout(() => {
        this.modalRefDescuentos = this.modalService.show(
          ModalHomeComponent,
          {
            backdrop: true,
            keyboard: true,
            focus: true,
            show: false,
            ignoreBackdropClick: false,
            class: 'modal-dialog modal-dialog-centered modal-lg',
            containerClass: 'top',
            animated: true,
            data: {}
          }
        );
      }, 500);
    }
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    // Cerrar el modal de descuentos si está abierto
    if (this.modalRefDescuentos) {
      this.modalRefDescuentos.hide();
    }
  }

  verificarCambiosCarrito(): void {
    const cantidadActual = this.carritoService.cantidadCarrito;
    if (cantidadActual !== this.cantidadAnterior) {
      // console.log('🔄 Procesar-pago: Detectado cambio en carrito, recargando...');
      this.obtenerCarrito();
      this.cantidadAnterior = cantidadActual;
    }
  }
  

  obtenerCarrito(){
    this.carritoDetalle = new CarritoHeader();
    this.carritoDetalle=this.carritoService.obtenerCarritoCompras()
    this.rellenarTotales();
  };

  async rellenarTotales(){
    this.SubTotalTemp = 0;
    this.precioTotal = 0;
    this.IGVDelivery = 0;
    this.IGVProducto = 0;
    this.IGVTotal = 0;
    this.cantidadTotal = 0;
    this.weightTotal = 0;
    this.monedaCarrito = 'S/.'; // Reset moneda
    this.isCalculatingTotal = true;
    // NO usar utilitarioService.loading para no bloquear toda la página
    // this.utilitarioService.loading=true;

    // Estructura temporal para cargar productos y calcular descuentos
    const productosTemp = [];

    for (let i = 0; i < this.carritoDetalle.lista.length; i++) {

        let libroDetalleTemp=new LibroDetalle();
        let libroSourvenirTemp=new SourvenirDetalleResponse();

        if(this.carritoDetalle.lista[i].tipoProducto=="1"){
          //recorre carrito en temporal con bd para obtener costos y detalle del producto uno por uno
          // Enviar userId para determinar nacionalidad por tipo de documento
          const userId = this.usuarioService.obtenerIDSessionUsuario();
          var libroDetalle:LibroDetalle = await this.novedadesService.obtenerDetalleLibroAsync(this.carritoDetalle.lista[i].id, userId).toPromise();
          libroDetalleTemp = libroDetalle;
          //console.log(libroDetalle);

          this.IGVProducto = this.IGVProducto + (Number(libroDetalle.response.list[0].igv_base) * Number(this.carritoDetalle.lista[i].cantidad));

          let modalidadEncontrada = libroDetalleTemp.response.list[0].modalidades.find(data=>
            data.id==this.carritoDetalle.lista[i].modalidadId
          );

          // Si la modalidad no existe (cambió de país), limpiar carrito y redirigir
          if (!modalidadEncontrada) {
            this.carritoService.limpiarCarrito();
            this.utilitarioService.toastrWarning('Tu carrito fue limpiado porque tu ubicación cambió. Los precios varían según tu país.');
            this.router.navigate(['/']);
            return;
          }

          let precio = modalidadEncontrada.price;

          // Determinar moneda del carrito basándose en el primer producto
          if (i === 0 && modalidadEncontrada && modalidadEncontrada.currency) {
            const currency = modalidadEncontrada.currency;
            if (currency === '$' || currency === 'USD' || currency === 'US$' ||
                currency.toLowerCase().includes('dolar') || currency.toLowerCase().includes('dollar')) {
              this.monedaCarrito = 'US$';
            } else {
              this.monedaCarrito = 'S/.';
            }
          }

          // Agregar a estructura temporal para agrupación
          productosTemp.push({
            categoria: this.obtenerCategoria(libroDetalleTemp.response.list[0].categoryName),
            modalidadId: this.carritoDetalle.lista[i].modalidadId,
            cantidad: Number(this.carritoDetalle.lista[i].cantidad),
            precioUnitario: Number(precio)
          });

          this.SubTotalTemp = Number((this.SubTotalTemp + ( Number(this.carritoDetalle.lista[i].cantidad) * Number(libroDetalleTemp.response.list[0].price_base) )).toFixed(2));

          this.cantidadTotal = this.cantidadTotal + Number(this.carritoDetalle.lista[i].cantidad);

          //this.weightTotal = this.weightTotal + Number(libroDetalleTemp.response.list[0].weight);
          this.weightTotal = this.weightTotal + ( Number(this.carritoDetalle.lista[i].cantidad) *  Number(libroDetalleTemp.response.list[0].weight) );

        }
        else if(this.carritoDetalle.lista[i].tipoProducto=="2"){
          //recorre carrito en temporal con bd para obtener costos y detalle del producto uno por uno
          var libroSourvenir:SourvenirDetalleResponse = await this.novedadesService.obtenerDetalleSourvenir(this.carritoDetalle.lista[i].id).toPromise();
          libroSourvenirTemp = libroSourvenir;
         //console.log(libroSourvenir);

         // console.log("Precio x Libro",libroSourvenirTemp.response.list[0].price);

          this.IGVProducto = this.IGVProducto + (Number(libroSourvenirTemp.response.list[0].igv_base) * Number(this.carritoDetalle.lista[i].cantidad));

          // Para souvenirs, usar precio directo sin agrupación de descuentos
          let precioSouvenir = Number(libroSourvenirTemp.response.list[0].price);
          productosTemp.push({
            categoria: 'souvenir',
            modalidadId: null,
            cantidad: Number(this.carritoDetalle.lista[i].cantidad),
            precioUnitario: precioSouvenir
          });

          this.SubTotalTemp = Number((this.SubTotalTemp + ( Number(this.carritoDetalle.lista[i].cantidad) * Number(libroSourvenirTemp.response.list[0].price_base) )).toFixed(2));

          this.cantidadTotal = this.cantidadTotal + Number(this.carritoDetalle.lista[i].cantidad);
          //this.weightTotal = this.weightTotal + Number(libroSourvenirTemp.response.list[0].weight);
          this.weightTotal = this.weightTotal + ( Number(this.carritoDetalle.lista[i].cantidad) *  Number(libroSourvenirTemp.response.list[0].weight) );

        }
    }

    // Calcular total con descuentos por agrupación
    const totalCalculado = this.calcularTotalConDescuentos(productosTemp);
    this.precioTotal = totalCalculado;




    //console.log("ingreso totales");
    let orderCalculateRequest = new OrderCalculateRequest();
    orderCalculateRequest.addressId = this.informacionEnvioComponent.rdbDireccionEnvio;
    orderCalculateRequest.amount = this.precioTotal.toString();
    orderCalculateRequest.quantity= this.cantidadTotal.toString();
    orderCalculateRequest.typeDeliveryId = this.informacionEnvioComponent.rdbTipoEntregaVal; //tipo entrega
    orderCalculateRequest.typeShippingId = "12"; //codigo pais peru
    orderCalculateRequest.weight = this.weightTotal.toString();

    if(this.informacionEnvioComponent.rdbDireccionEnvio==null || this.informacionEnvioComponent.rdbDireccionEnvio == undefined || this.informacionEnvioComponent.rdbDireccionEnvio == "0"){
      this.orderCalculateResponse.response.list = [{subtotalCost:orderCalculateRequest.amount,shippingCost:"0",igvCost:"0",totalCost:orderCalculateRequest.amount}];
      // this.utilitarioService.loading=false; // NO usar loading global
      this.isCalculatingTotal = false;
      this.IGVTotal = this.IGVProducto + this.IGVDelivery;
      return;
    }
    //console.log(orderCalculateRequest);
    this.procesarPagoService.obtenerCalculoTotales(orderCalculateRequest).subscribe(data => {

      // console.log(data);
      // this.utilitarioService.loading=false; // NO usar loading global
      this.isCalculatingTotal = false;
      if (data.response.codeResponse!="0000"){this.utilitarioService.toastrError(data.response.response); return;}

      this.orderCalculateResponse = data;
      this.IGVDelivery = Number(this.orderCalculateResponse.response.list[0].igvCost);

      this.IGVTotal = this.IGVProducto + this.IGVDelivery;
    },
    (err:any) => {
      // this.utilitarioService.loading=false; // NO usar loading global
      this.utilitarioService.toastrError("Ocurrio un error en el Servicio");
      this.isCalculatingTotal = false;
      //console.log(err);
    });

  }

  // ========== MÉTODOS PARA CÁLCULO DE DESCUENTOS POR AGRUPACIÓN ==========

  /**
   * Identifica la categoría del producto
   */
  obtenerCategoria(categoryName: string): string {
    if (!categoryName) return 'otro';

    const catUpper = categoryName.toUpperCase();
    if (catUpper.includes('FOTOGRAFIA')) return 'fotografia';
    if (catUpper.includes('PORTADA')) return 'portada';
    return 'otro';
  }

  /**
   * Agrupa productos por categoría y modalidad, y calcula el total con descuentos
   */
  calcularTotalConDescuentos(productos: any[]): number {
    // Limpiar resumen anterior
    this.resumenPedido = {
      grupos: [],
      subtotalSinDescuento: 0,
      totalDescuentos: 0,
      totalFinal: 0
    };

    // Estructura para agrupar: Map<"categoria-modalidadId", {cantidad, precioUnitario}>
    const grupos = new Map<string, {totalUnidades: number, precioUnitario: number, categoria: string, modalidadId: string}>();

    // 1. Agrupar productos por categoría + modalidad
    productos.forEach(prod => {
      // Souvenirs no se agrupan para descuentos
      if (prod.categoria === 'souvenir') {
        const key = `souvenir-${Math.random()}`; // Clave única para cada souvenir
        grupos.set(key, {
          totalUnidades: prod.cantidad,
          precioUnitario: prod.precioUnitario,
          categoria: 'souvenir',
          modalidadId: null
        });
        return;
      }

      // Para fotografías y portadas: agrupar por categoria-modalidad
      const key = `${prod.categoria}-${prod.modalidadId}`;

      if (grupos.has(key)) {
        const grupo = grupos.get(key);
        grupo.totalUnidades += prod.cantidad;
      } else {
        grupos.set(key, {
          totalUnidades: prod.cantidad,
          precioUnitario: prod.precioUnitario,
          categoria: prod.categoria,
          modalidadId: prod.modalidadId
        });
      }
    });

    // 2. Calcular total aplicando descuentos por grupo
    let totalGeneral = 0;
    let subtotalSinDescuento = 0;
    let totalDescuentos = 0;

    grupos.forEach((grupo, key) => {
      const { totalUnidades, precioUnitario, categoria, modalidadId } = grupo;

      // Calcular subtotal sin descuento
      const subtotalOriginal = totalUnidades * precioUnitario;
      subtotalSinDescuento += subtotalOriginal;

      // Si es souvenir, calcular sin descuentos
      if (key.startsWith('souvenir-')) {
        totalGeneral += totalUnidades * precioUnitario;

        this.resumenPedido.grupos.push({
          categoria: 'Souvenir',
          modalidad: 'N/A',
          cantidad: totalUnidades,
          precioUnitario: precioUnitario,
          subtotal: totalUnidades * precioUnitario,
          descuento: 0,
          porcentajeDescuento: '0%'
        });
        return;
      }

      // Aplicar reglas de descuento según cantidad
      let subtotal = 0;
      let descuento = 0;
      let porcentajeDescuento = '0%';

      if (totalUnidades >= 1 && totalUnidades <= 4) {
        // Sin descuento
        subtotal = totalUnidades * precioUnitario;
        descuento = 0;
        porcentajeDescuento = '0%';

      } else if (totalUnidades === 5) {
        // Pack de 5: pagas 4, llevas 5 (20% descuento efectivo)
        subtotal = 4 * precioUnitario;
        descuento = precioUnitario; // Te ahorras 1 unidad
        porcentajeDescuento = '20%';

      } else if (totalUnidades >= 6 && totalUnidades <= 24) {
        // 20% de descuento
        const precioConDescuento = precioUnitario * 0.8;
        subtotal = totalUnidades * precioConDescuento;
        descuento = subtotalOriginal - subtotal;
        porcentajeDescuento = '20%';

      } else if (totalUnidades >= 25) {
        // 28% de descuento total (20% + 10% adicional)
        const precioConPrimerDescuento = precioUnitario * 0.8;
        const precioFinal = precioConPrimerDescuento * 0.9;
        subtotal = totalUnidades * precioFinal;
        descuento = subtotalOriginal - subtotal;
        porcentajeDescuento = '20% + 10% adicional';
      }

      totalGeneral += subtotal;
      totalDescuentos += descuento;

      // Obtener nombre de categoría y modalidad
      const categoriaNombre = this.obtenerNombreCategoria(categoria);
      const modalidadNombre = this.obtenerNombreModalidad(modalidadId);

      // Agregar al desglose
      this.resumenPedido.grupos.push({
        categoria: categoriaNombre,
        modalidad: modalidadNombre,
        cantidad: totalUnidades,
        precioUnitario: precioUnitario,
        subtotal: subtotal,
        descuento: descuento,
        porcentajeDescuento: porcentajeDescuento
      });
    });

    // Actualizar resumen
    this.resumenPedido.subtotalSinDescuento = Number(subtotalSinDescuento.toFixed(2));
    this.resumenPedido.totalDescuentos = Number(totalDescuentos.toFixed(2));
    this.resumenPedido.totalFinal = Number(totalGeneral.toFixed(2));

    return Number(totalGeneral.toFixed(2));
  }

  /**
   * Obtiene el nombre legible de la categoría
   */
  obtenerNombreCategoria(categoria: string): string {
    const nombres = {
      'fotografia': 'Fotografías',
      'portada': 'Páginas Históricas',
      'souvenir': 'Souvenirs',
      'otro': 'Otros'
    };
    return nombres[categoria] || categoria;
  }

  /**
   * Obtiene el nombre legible de la modalidad
   */
  obtenerNombreModalidad(modalidadId: string): string {
    if (!modalidadId) return 'N/A';

    const nombres = {
      '1': 'Particular Nacional (N)',
      '2': 'Comercial Nacional (CN)',
      '3': 'Comercial Extranjero (CE)'
    };
    return nombres[modalidadId] || `Modalidad ${modalidadId}`;
  }

  onCargarDatosPersonales() {          

    //this.personaBeanM.direccion = (<HTMLInputElement>document.getElementById("txt_buscar_flag")).value;
    this.addressId = (<HTMLInputElement>document.getElementById("txtaddressId")).value;
    this.typeDeliveryId = (<HTMLInputElement>document.getElementById("txttypeDeliveryId")).value;       
    
 
   }

  ngAfterViewInit() {
    //this.addressId = this.informacionEnvioComponent.rdbDireccionEnvio;
    this.obtenerCarrito();
  }

  recibirMensajeHijoInf(mensaje:String){    
    this.obtenerCarrito();
  }

  recibirOrder(orderRequestInformacion:OrderRequest){
    //console.log(orderRequestInformacion);
    this.orderRequestInfoEnvio = orderRequestInformacion;
  }

  abrirModalTerminos(){
    this.mostrarModalTerminos = true;
  }

  cerrarModalTerminos(){
    this.mostrarModalTerminos = false;
    // Al cerrar el modal sin aceptar, desmarcar el checkbox
    this.informacionEnvioComponent.flagTerminosCondiciones = false;
  }

  aceptarTerminos(){
    this.mostrarModalTerminos = false;
    // Al aceptar, marcar el checkbox
    this.informacionEnvioComponent.flagTerminosCondiciones = true;
  }

}
